module.exports = __webpack_public_path__ + "04_glasses_red.842fe1fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/04_glasses_red.png
// module id = syRw
// module chunks = 0